import { EllipsisIcon } from 'lucide-react';

import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger,
} from '@crossnokaye/ux-common/ckds';

import { useJumpToEquipment } from './useJumpToEquipment';

export const JumpToEquipmentDropdown = () => {
  const { sections, getEquipmentBySection, handleEquipmentClick } = useJumpToEquipment();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button size={'md'} variant={'tier3'} shape={'square'}>
          <EllipsisIcon className="w-5 h-5" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="min-w-72" withPortal>
        <DropdownMenuLabel>Equipment Categories</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {sections?.map((section) => (
          <DropdownMenuSub key={section.id}>
            <DropdownMenuSubTrigger className="capitalize">{section.name}</DropdownMenuSubTrigger>
            <DropdownMenuSubContent>
              <DropdownMenuLabel>Select Equipment</DropdownMenuLabel>
              {getEquipmentBySection(section)?.map((equipment) => (
                <DropdownMenuItem
                  key={`${section.name}-${equipment.referenceId}`}
                  onClick={() => handleEquipmentClick(equipment, section)}
                >
                  {equipment.title}
                </DropdownMenuItem>
              ))}
            </DropdownMenuSubContent>
          </DropdownMenuSub>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
